module.exports = __webpack_public_path__ + "img/Barbarian.8522ab56.png";